// extracted by mini-css-extract-plugin
export default {"settingsSection":"CreateContestForm_settingsSection__OLu-A"};